<template>
  <v-navigation-drawer
    id="app-drawer"
    :value="leftBar"
    app
    dark
    floating
    persistent
    mobile-break-point="991"
    width="260"
    color="primary"
    :class="'text-left left-nav disable-list-item-flex'"
    >
      <v-layout class="fill-height" tag="v-list" column>
        <v-list class="mt-2 py-2">
          <v-list-item class="title text-xs-center h-auto">
            <img class="branding-logo" v-if="$store.getters.getLoggedInUserSelectedBusinessBrandingLogo" :src="$store.getters.getLoggedInUserSelectedBusinessBrandingLogo"> 
            <img class="branding-logo" v-else src="../assets/images/uno-logo.png"> 
          </v-list-item>
        </v-list>
        <v-divider class="mt-2"/>

          <template v-for="(nav,index) in navigation">
            <nav-item v-bind:key="index"  :nav="nav"></nav-item>
          </template>

    </v-layout>
  </v-navigation-drawer>
</template>
<script>
import { mapGetters } from 'vuex';
import NavItem from './Custom-components/NavItem';
import store from '@/store/store';

export default {
   components: {
    NavItem,  
  },

  data() {
    return {
      navigation: [
      ],
      availablePermissions: [
        'is_superadmin',
        'is_unoapp',
        'is_corporate',
        'is_admin',
      ],
    };
  },

  computed: {
     secondaryColor() {
      return this.$store.getters.getLoggedInUserSelectedBusinessBrandingSecondary;
    },
    ...mapGetters({
      leftBar: 'navigation/leftNavStatus',
    }),
    userName() {
      return `${this.$store.getters.getLoggedInUser.first_name} ${this.$store.getters.getLoggedInUser.last_name}`;
    },
    userEmail() {
      return this.$store.getters.getLoggedInUser.email;
    },
    permissions () {
      return {
        is_superadmin: this.$store.getters.is_superadmin,
        is_unoapp: this.$store.getters.is_unoapp,
        is_admin: this.$store.getters.is_admin,
        is_corporate: this.$store.getters.is_corporate,
      };
    },
  },
  created() {
    const self = this;
    /**
     * Get all the items from router and check for addtoNav = true
     */
    this.$router.options.routes.forEach((route) => {
      if (route.addtoNav === true) {

        let routeAccess = route.checkAccess ? route.checkAccess.split('|') : '';
        let item = {
          title: route.navText,
          path: route.path,
          icon: route.icon,
          name: route.name,
          styleClass: route.styleClass,
        };
        if(routeAccess == '') {
          self.navigation.push(item);
        } else {
          for (var i = 0; i < routeAccess.length; i++) {
            if (this.permissions[routeAccess[i]]){
               self.navigation.push(item);
              break;
            }
          }
        }
      }
      // Check if we have childrens
      if ('children' in route) {
        route.children.forEach((childRoute) => {
          if (childRoute.addtoNav === true) {
              let childRouterAccess = childRoute.checkAccess ? childRoute.checkAccess.split('|') : '';
              let childItem = {
                title: childRoute.navText,
                path: childRoute.path,
                icon: childRoute.icon,
                name: childRoute.name,
                styleClass: childRoute.styleClass,
              };
              if(childRouterAccess == '') {
                self.navigation.push(childItem);
              } else {
                for (var i = 0; i < childRouterAccess.length; i++) {
                  if (this.permissions[childRouterAccess[i]]){
                    self.navigation.push(childItem);
                    break;
                  }
                }
              }
          }
        });
      }
    });
  },
  methods: {

    logout() {

    },
  },
};
</script>
<style scoped>
.branding-logo{
  max-width: 80%;
  height: 60px;
  width: auto;
}
.settings.left-nav-item {
    position: absolute;
    width: 100%;
    bottom: 0;
}
</style>